import React, { FC, ReactNode } from 'react';
import { Collapse } from 'antd';

import 'assets/scss/accordion.scss';

import { DxIcon } from 'components/common';

interface IAccordion {
    data: {
        title: string;
        content: ReactNode;
    }[];
}

const Accordion: FC<IAccordion> = ({ data }) => {
    const { Panel } = Collapse;

    return (
        <div>
            <Collapse accordion={true} expandIconPosition="right" className="dx-collapse">
                {data.map(({ title, content }) => (
                    <Panel
                        showArrow={false}
                        header={
                            <div className="collapse-title-outer d-flex justify-content-between gap-4 align-items-center">
                                <div className="collapse-title">{title}</div>
                                <DxIcon type={'chevron_down'} size="md" />
                            </div>
                        }
                        key={title}
                    >
                        {content}
                    </Panel>
                ))}
            </Collapse>
        </div>
    );
};

export default Accordion;
